import React from 'react';
import './cards-sec7.css'
import pic24 from '../../assets/pic24.png'
import pic28 from '../../assets/pic28.png'
import { useState } from 'react';
import { useEffect } from 'react';

const Cardsec7 = (props) => {


 const [animate, setAnimate] = useState(false);
    const [wasInView, setWasInView] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const section = document.querySelector('.sec7');

            if (section) {
                const rect = section.getBoundingClientRect();
                const windowHeight = window.innerHeight;

                const isInView = rect.top < windowHeight && rect.bottom > 0;

                if (isInView && !wasInView) {
                    setAnimate(false);
                    setTimeout(() => {
                        setAnimate(true);
                    }, 50);
                    setWasInView(true);
                }

                if (!isInView && wasInView) {
                    setAnimate(false);
                    setWasInView(false);
                }
            }
        };

        handleScroll();
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [wasInView]);






    return ( 
        <article className={`card-sec7 ${animate ? 'animate' : ''}`}>
                <img className='triangle-sec2' src={pic24} alt='pic'></img>
                <article className='profile-part-sec7'>
                    <img src={props.img} alt='img'></img>
                    <article className='sub-profile-sec7'>
                        <h2 className='name-sec7'>{props.title}</h2>
                        <article className='rating-cont'>
                            <h3 className='numb-sec7'>{props.numb}</h3>
                            <img src={pic28} alt='pic'></img>
                        </article>
                    </article>
                </article>

                <p className='para-sec7'>{props.para}</p>
        </article>
     );
}
 
export default Cardsec7;